export default __webpack_public_path__ + "static/media/robbert_bw_400x400.ffbc2169.jpg";